import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=55205f1e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=55205f1e&prod&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=55205f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55205f1e",
  null
  
)

export default component.exports